module.exports = __webpack_public_path__ + "img/label1.40307854.png";